"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.X = exports.Instagram = void 0;
var Instagram_1 = require("./Instagram");
Object.defineProperty(exports, "Instagram", { enumerable: true, get: function () { return Instagram_1.Instagram; } });
var X_1 = require("./X");
Object.defineProperty(exports, "X", { enumerable: true, get: function () { return X_1.X; } });
